var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { TreeReportsList } from "./treeReportsList";
export var TreeReportsItem = function (_a) {
    var _b;
    var item = _a.item, index = _a.index, level = _a.level, isOpen = _a.isOpen, _c = _a.updateAORModule, updateAORModule = _c === void 0 ? function () { } : _c, anyOpen = _a.anyOpen, setAnyOpen = _a.setAnyOpen;
    var _d = useState(isOpen || false), open = _d[0], setOpen = _d[1];
    var style = level === 0 ? "ml-0" : "ml-4";
    //const styleSelected = open ? "bg-[var(--colors-facelift)]" : "";
    var styleSelected = open
        ? "bg-[var(--colors-facelift)]" // module ouvert
        : level === 0 && index === 0 && !anyOpen
            ? "bg-[var(--colors-facelift)]"
            : "";
    var isModule = item.type === "module";
    var updateReportsModule = function (m) {
        updateAORModule(m);
    };
    var handleOpen = function () {
        if (item.type === "relationship") {
            var newOpen = !open;
            setAnyOpen(newOpen);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "".concat(style, " px-2") }, { children: [_jsx("div", { children: _jsxs("span", __assign({ className: "flex flex-row ".concat(styleSelected), onClick: function (e) {
                            handleOpen();
                            item.type === "relationship" && setOpen(!open);
                        } }, { children: [open ? (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-4 h-4 mt-1 mr-1 cursor-pointer" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M19.5 8.25l-7.5 7.5-7.5-7.5" }) }))) : (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-4 h-4 mt-1 mr-1 cursor-pointer\n                ".concat(level === 0 && index === 0 ? "-ml-3" : "") }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M8.25 4.5l7.5 7.5-7.5 7.5" }) }))), _jsx("span", __assign({ className: "cursor-pointer relative", onClick: function () {
                                    isModule && updateAORModule(item.module);
                                } }, { children: ((_b = item.label) === null || _b === void 0 ? void 0 : _b.includes(":"))
                                    ? item.label.split(":")[1].trim()
                                    : item.label }))] })) }), open && item.type !== "module" && (_jsx(TreeReportsList, { module: item.module, level: level + 1, updateAORModuleList: updateReportsModule }))] })) }));
};
